import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
} from "@mui/material";
import { CSSProperties, useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

export type useDialogProps = {
  title?: string;
  children?: JSX.Element;
  sx?: CSSProperties;
  dialogSize?: "xs" | "sm" | "md" | "lg" | "xl";
  closeButton?: boolean;
  actionCloseButton?: boolean;
  actionConfirmButton?: boolean;
  actionOnClose?: () => void;
  actionOnConfirm?: () => void;
};

export const useDialog = (
  props: useDialogProps
): [CustomizatedDialog: () => JSX.Element, controlDialog: () => void] => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const controlDialog = () => {
    setOpen(!open);
  };

  const CustomizatedDialog = () => {
    return (
      <Dialog
        onClose={controlDialog}
        open={open}
        sx={props.sx}
        fullWidth={true}
        maxWidth={props.dialogSize ?? "sm"}
      >
        <Box display="flex" justifyContent={"space-between"}>
          {props.title ? <DialogTitle>{props.title}</DialogTitle> : <></>}
          {props.closeButton ? (
            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          ) : (
            <></>
          )}
        </Box>
        <DialogContent>{props.children ?? <></>}</DialogContent>
        <Box
          display="flex"
          justifyContent="space-evenly"
          sx={{ margin: "20px 0px" }}
        >
          {props.actionConfirmButton && (
            <Button
              variant="contained"
              color="defaultButton"
              onClick={() => {
                if (props.actionOnConfirm) props.actionOnConfirm();
                setOpen(false);
              }}
            >
              {t("Confirm")}
            </Button>
          )}
          {props.actionCloseButton && (
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                if (props.actionOnClose) props.actionOnClose();
                setOpen(false);
              }}
            >
              {t("Cancel")}
            </Button>
          )}
        </Box>
      </Dialog>
    );
  };

  return [CustomizatedDialog, controlDialog];
};
